import { render } from "./VolTable.vue?vue&type=template&id=503b987f&scoped=true"
import script from "./VolTable.vue?vue&type=script&lang=js"
export * from "./VolTable.vue?vue&type=script&lang=js"

import "./VolTable.vue?vue&type=style&index=0&id=503b987f&lang=less&scoped=true"
import "./VolTable.vue?vue&type=style&index=1&id=503b987f&scoped=true&lang=css"

import exportComponent from "/root/workspace/KpiManage-vue_PVju/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503b987f"]])

export default __exports__